export default __webpack_public_path__ + "static/media/DinaDehaini.17228293.PNG";